import { Container, CssBaseline, Fab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../components/Navbar";
import SearchBox from "../components/SearchBox";
import ScrollTop from "../components/ScrollTop";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GroupageList from "../components/GroupageList";
import { getGroupages, reset } from "../features/groupages/groupageSlices";
import { logout } from "../features/auth/authSlice";
import { reset as resetShipment } from "../features/shipments/shipmentSlice";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

const Groupages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useSelector((state) => state.auth);
  const { isError, message, isSuccess } = useSelector(
    (state) => state.groupages
  );
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("q") ?? "";

  const handleSearchQueryChanged = (newQuery) => {
    const queryParams = { q: newQuery };
    const qString = queryString.stringify(queryParams);
    navigate(`/groupages?${qString}`);
  };

  const loadGroupages = () => {
    const params = { q: query };
    dispatch(resetShipment());
    dispatch(getGroupages(params));
  };

  useEffect(() => {
    if (!isSuccess && isError && message === "Unauthorized") {
      dispatch(reset());
      dispatch(logout());
    }
  }, [user, isError, message, dispatch, isSuccess]);

  useEffect(() => {
    console.log(user);
    if (!user) {
      navigate("/login");
    }
  }, [user]);

  useEffect(() => {
    loadGroupages();
  }, [query]);

  return (
    <div>
      <CssBaseline />
      {user && (
        <Navbar isAdmin={user.role === "SUPERADMIN" || user.role === "ADMIN"} />
      )}
      <Container maxWidth="sm">
        <div id="back-to-top-anchor"></div>
        <SearchBox
          label={"Search Groupage"}
          placeholder={"Groupage No. / Shipment No."}
          query={query}
          onQueryChanged={handleSearchQueryChanged}
        />
        <GroupageList />
      </Container>

      <ScrollTop>
        <Fab aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </div>
  );
};

export default Groupages;
